export const attachmentsConfig = [
  { mimeType: 'image/jpeg', maxSizeBytes: 20971520 },
  { mimeType: 'image/png', maxSizeBytes: 20971520 },
  { mimeType: 'application/pdf', maxSizeBytes: 20971520 },
];
